// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Last Update */
.last-update {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #f1f6f6;
}

.last-update-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #7a8a8a;
}

.last-update-date {
  font-size: 0.875rem;
  font-weight: 600;
  color: #2c5f5f;
}

/* Mini Stat Cards */
.mini-stat-card {
  padding: 1rem;
  border-radius: 12px;
  background: #f8f9fa;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.mini-stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.mini-stat-card .mini-value {
  display: block;
  font-size: 1.75rem;
  font-weight: 700;
  color: #2c5f5f;
  margin-bottom: 0.25rem;
}

.mini-stat-card .mini-label {
  display: block;
  font-size: 0.875rem;
  color: #7a8a8a;
  font-weight: 500;
}

.mini-stat-card.info {
  background: linear-gradient(135deg, #e3f2fd 0%, #f0f8ff 100%);
  border-left: 4px solid #007AFF;
}

.mini-stat-card.info .mini-value {
  color: #007AFF;
}

.mini-stat-card.success {
  background: linear-gradient(135deg, #e8f5e9 0%, #f1f8f4 100%);
  border-left: 4px solid #23A566;
}

.mini-stat-card.success .mini-value {
  color: #23A566;
}

.mini-stat-card.warning {
  background: linear-gradient(135deg, #fff8e1 0%, #fffcf2 100%);
  border-left: 4px solid #FF9500;
}

.mini-stat-card.warning .mini-value {
  color: #FF9500;
}

.mini-stat-card.danger {
  background: linear-gradient(135deg, #ffebee 0%, #fff5f5 100%);
  border-left: 4px solid #FF3B30;
}

.mini-stat-card.danger .mini-value {
  color: #FF3B30;
}

.mini-stat-card.purple {
  background: linear-gradient(135deg, #f3e5f5 0%, #faf5ff 100%);
  border-left: 4px solid #A78BFA;
}

.mini-stat-card.purple .mini-value {
  color: #A78BFA;
}

/* Event Type Legend */
.event-type-legend {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  flex-shrink: 0;
}

.legend-text {
  font-size: 0.9rem;
  color: #2c5f5f;
  font-weight: 500;
}

/* Campaign Gauge Wrapper */
.campaign-gauge-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem 0;
}

/* Additional Dashboard Card Enhancements */
.card {
  border: none;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
}

.card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

.card-header {
  background: #fff;
  border-bottom: 1px solid #f1f6f6;
  padding: 1.25rem 1.5rem;
}

.card-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #2c5f5f;
  margin: 0;
}

.card-body {
  padding: 1.5rem;
}

/* Chart Containers */
.card-body .row {
  margin: 0 -0.75rem;
}

.card-body .row > .col,
.card-body .row > [class*="col-"] {
  padding: 0 0.75rem;
}

/* Responsive Adjustments */
@media (max-width: 991.98px) {
  .mini-stat-card .mini-value {
    font-size: 1.5rem;
  }
  
  .mini-stat-card .mini-label {
    font-size: 0.8rem;
  }
}

@media (max-width: 767.98px) {
  .event-type-legend {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .card-header,
  .card-body {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/dashboard.component.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":["/* Last Update */\r\n.last-update {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 0.5rem 1rem;\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  border: 1px solid #f1f6f6;\r\n}\r\n\r\n.last-update-label {\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  color: #7a8a8a;\r\n}\r\n\r\n.last-update-date {\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  color: #2c5f5f;\r\n}\r\n\r\n/* Mini Stat Cards */\r\n.mini-stat-card {\r\n  padding: 1rem;\r\n  border-radius: 12px;\r\n  background: #f8f9fa;\r\n  text-align: center;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.mini-stat-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.mini-stat-card .mini-value {\r\n  display: block;\r\n  font-size: 1.75rem;\r\n  font-weight: 700;\r\n  color: #2c5f5f;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.mini-stat-card .mini-label {\r\n  display: block;\r\n  font-size: 0.875rem;\r\n  color: #7a8a8a;\r\n  font-weight: 500;\r\n}\r\n\r\n.mini-stat-card.info {\r\n  background: linear-gradient(135deg, #e3f2fd 0%, #f0f8ff 100%);\r\n  border-left: 4px solid #007AFF;\r\n}\r\n\r\n.mini-stat-card.info .mini-value {\r\n  color: #007AFF;\r\n}\r\n\r\n.mini-stat-card.success {\r\n  background: linear-gradient(135deg, #e8f5e9 0%, #f1f8f4 100%);\r\n  border-left: 4px solid #23A566;\r\n}\r\n\r\n.mini-stat-card.success .mini-value {\r\n  color: #23A566;\r\n}\r\n\r\n.mini-stat-card.warning {\r\n  background: linear-gradient(135deg, #fff8e1 0%, #fffcf2 100%);\r\n  border-left: 4px solid #FF9500;\r\n}\r\n\r\n.mini-stat-card.warning .mini-value {\r\n  color: #FF9500;\r\n}\r\n\r\n.mini-stat-card.danger {\r\n  background: linear-gradient(135deg, #ffebee 0%, #fff5f5 100%);\r\n  border-left: 4px solid #FF3B30;\r\n}\r\n\r\n.mini-stat-card.danger .mini-value {\r\n  color: #FF3B30;\r\n}\r\n\r\n.mini-stat-card.purple {\r\n  background: linear-gradient(135deg, #f3e5f5 0%, #faf5ff 100%);\r\n  border-left: 4px solid #A78BFA;\r\n}\r\n\r\n.mini-stat-card.purple .mini-value {\r\n  color: #A78BFA;\r\n}\r\n\r\n/* Event Type Legend */\r\n.event-type-legend {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n  padding: 1rem;\r\n}\r\n\r\n.legend-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.legend-color {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.legend-text {\r\n  font-size: 0.9rem;\r\n  color: #2c5f5f;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Campaign Gauge Wrapper */\r\n.campaign-gauge-wrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 1rem 0;\r\n}\r\n\r\n/* Additional Dashboard Card Enhancements */\r\n.card {\r\n  border: none;\r\n  border-radius: 16px;\r\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\r\n  transition: all 0.3s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n.card:hover {\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.card-header {\r\n  background: #fff;\r\n  border-bottom: 1px solid #f1f6f6;\r\n  padding: 1.25rem 1.5rem;\r\n}\r\n\r\n.card-title {\r\n  font-size: 1.125rem;\r\n  font-weight: 600;\r\n  color: #2c5f5f;\r\n  margin: 0;\r\n}\r\n\r\n.card-body {\r\n  padding: 1.5rem;\r\n}\r\n\r\n/* Chart Containers */\r\n.card-body .row {\r\n  margin: 0 -0.75rem;\r\n}\r\n\r\n.card-body .row > .col,\r\n.card-body .row > [class*=\"col-\"] {\r\n  padding: 0 0.75rem;\r\n}\r\n\r\n/* Responsive Adjustments */\r\n@media (max-width: 991.98px) {\r\n  .mini-stat-card .mini-value {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  .mini-stat-card .mini-label {\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n  .event-type-legend {\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .card-header,\r\n  .card-body {\r\n    padding: 1rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
